/**
 * belfastpilates-development.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.BelfastpilatesDevelopmentappspotcom) {
      root.BelfastpilatesDevelopmentappspotcom = {};
    }
    root.BelfastpilatesDevelopmentappspotcom.ScheduleBean = factory(root.BelfastpilatesDevelopmentappspotcom.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The ScheduleBean model module.
   * @module model/ScheduleBean
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>ScheduleBean</code>.
   * @alias module:model/ScheduleBean
   * @class
   */
  var exports = function() {
    var _this = this;



































































  };

  /**
   * Constructs a <code>ScheduleBean</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ScheduleBean} obj Optional instance to populate.
   * @return {module:model/ScheduleBean} The populated <code>ScheduleBean</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('body')) {
        obj['body'] = ApiClient.convertToType(data['body'], 'String');
      }
      if (data.hasOwnProperty('countryCode')) {
        obj['countryCode'] = ApiClient.convertToType(data['countryCode'], 'String');
      }
      if (data.hasOwnProperty('currencyCode')) {
        obj['currencyCode'] = ApiClient.convertToType(data['currencyCode'], 'String');
      }
      if (data.hasOwnProperty('dateCreated')) {
        obj['dateCreated'] = ApiClient.convertToType(data['dateCreated'], 'Date');
      }
      if (data.hasOwnProperty('dayOfMonth')) {
        obj['dayOfMonth'] = ApiClient.convertToType(data['dayOfMonth'], 'String');
      }
      if (data.hasOwnProperty('dayPeriodOfMonth')) {
        obj['dayPeriodOfMonth'] = ApiClient.convertToType(data['dayPeriodOfMonth'], 'String');
      }
      if (data.hasOwnProperty('dependencies')) {
        obj['dependencies'] = ApiClient.convertToType(data['dependencies'], 'String');
      }
      if (data.hasOwnProperty('derivedFrom')) {
        obj['derivedFrom'] = ApiClient.convertToType(data['derivedFrom'], 'String');
      }
      if (data.hasOwnProperty('description')) {
        obj['description'] = ApiClient.convertToType(data['description'], 'String');
      }
      if (data.hasOwnProperty('displayDate')) {
        obj['displayDate'] = ApiClient.convertToType(data['displayDate'], 'String');
      }
      if (data.hasOwnProperty('displayDay')) {
        obj['displayDay'] = ApiClient.convertToType(data['displayDay'], 'String');
      }
      if (data.hasOwnProperty('endAfterRecurrences')) {
        obj['endAfterRecurrences'] = ApiClient.convertToType(data['endAfterRecurrences'], 'String');
      }
      if (data.hasOwnProperty('endTime')) {
        obj['endTime'] = ApiClient.convertToType(data['endTime'], 'String');
      }
      if (data.hasOwnProperty('everyNoOfDays')) {
        obj['everyNoOfDays'] = ApiClient.convertToType(data['everyNoOfDays'], 'String');
      }
      if (data.hasOwnProperty('everyNoOfMonths')) {
        obj['everyNoOfMonths'] = ApiClient.convertToType(data['everyNoOfMonths'], 'String');
      }
      if (data.hasOwnProperty('everyNoOfWeeks')) {
        obj['everyNoOfWeeks'] = ApiClient.convertToType(data['everyNoOfWeeks'], 'String');
      }
      if (data.hasOwnProperty('everyWeek')) {
        obj['everyWeek'] = ApiClient.convertToType(data['everyWeek'], 'String');
      }
      if (data.hasOwnProperty('friday')) {
        obj['friday'] = ApiClient.convertToType(data['friday'], 'String');
      }
      if (data.hasOwnProperty('fridayTime')) {
        obj['fridayTime'] = ApiClient.convertToType(data['fridayTime'], ['Date']);
      }
      if (data.hasOwnProperty('generateEndDate')) {
        obj['generateEndDate'] = ApiClient.convertToType(data['generateEndDate'], 'Date');
      }
      if (data.hasOwnProperty('generateStartDate')) {
        obj['generateStartDate'] = ApiClient.convertToType(data['generateStartDate'], 'Date');
      }
      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'String');
      }
      if (data.hasOwnProperty('instructorIds')) {
        obj['instructorIds'] = ApiClient.convertToType(data['instructorIds'], ['String']);
      }
      if (data.hasOwnProperty('lastUpdatedDateTime')) {
        obj['lastUpdatedDateTime'] = ApiClient.convertToType(data['lastUpdatedDateTime'], 'Date');
      }
      if (data.hasOwnProperty('managerComments')) {
        obj['managerComments'] = ApiClient.convertToType(data['managerComments'], 'String');
      }
      if (data.hasOwnProperty('maxSpace')) {
        obj['maxSpace'] = ApiClient.convertToType(data['maxSpace'], 'Number');
      }
      if (data.hasOwnProperty('message')) {
        obj['message'] = ApiClient.convertToType(data['message'], 'String');
      }
      if (data.hasOwnProperty('monday')) {
        obj['monday'] = ApiClient.convertToType(data['monday'], 'String');
      }
      if (data.hasOwnProperty('mondayTime')) {
        obj['mondayTime'] = ApiClient.convertToType(data['mondayTime'], ['Date']);
      }
      if (data.hasOwnProperty('name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String');
      }
      if (data.hasOwnProperty('notificationUserIds')) {
        obj['notificationUserIds'] = ApiClient.convertToType(data['notificationUserIds'], ['String']);
      }
      if (data.hasOwnProperty('numberOfBooks')) {
        obj['numberOfBooks'] = ApiClient.convertToType(data['numberOfBooks'], 'Number');
      }
      if (data.hasOwnProperty('numberOfDaysToGenerate')) {
        obj['numberOfDaysToGenerate'] = ApiClient.convertToType(data['numberOfDaysToGenerate'], 'String');
      }
      if (data.hasOwnProperty('price')) {
        obj['price'] = ApiClient.convertToType(data['price'], 'String');
      }
      if (data.hasOwnProperty('priority')) {
        obj['priority'] = ApiClient.convertToType(data['priority'], 'String');
      }
      if (data.hasOwnProperty('recurrenceEndDate')) {
        obj['recurrenceEndDate'] = ApiClient.convertToType(data['recurrenceEndDate'], 'Date');
      }
      if (data.hasOwnProperty('recurrenceStartDate')) {
        obj['recurrenceStartDate'] = ApiClient.convertToType(data['recurrenceStartDate'], 'Date');
      }
      if (data.hasOwnProperty('recurrenceType')) {
        obj['recurrenceType'] = ApiClient.convertToType(data['recurrenceType'], 'String');
      }
      if (data.hasOwnProperty('roleType')) {
        obj['roleType'] = ApiClient.convertToType(data['roleType'], 'String');
      }
      if (data.hasOwnProperty('roomId')) {
        obj['roomId'] = ApiClient.convertToType(data['roomId'], 'String');
      }
      if (data.hasOwnProperty('saturday')) {
        obj['saturday'] = ApiClient.convertToType(data['saturday'], 'String');
      }
      if (data.hasOwnProperty('saturdayTime')) {
        obj['saturdayTime'] = ApiClient.convertToType(data['saturdayTime'], ['Date']);
      }
      if (data.hasOwnProperty('searchId')) {
        obj['searchId'] = ApiClient.convertToType(data['searchId'], 'String');
      }
      if (data.hasOwnProperty('serviceId')) {
        obj['serviceId'] = ApiClient.convertToType(data['serviceId'], 'String');
      }
      if (data.hasOwnProperty('setId')) {
        obj['setId'] = ApiClient.convertToType(data['setId'], 'String');
      }
      if (data.hasOwnProperty('setsRequired')) {
        obj['setsRequired'] = ApiClient.convertToType(data['setsRequired'], 'Boolean');
      }
      if (data.hasOwnProperty('shift')) {
        obj['shift'] = ApiClient.convertToType(data['shift'], 'String');
      }
      if (data.hasOwnProperty('startDate')) {
        obj['startDate'] = ApiClient.convertToType(data['startDate'], 'Date');
      }
      if (data.hasOwnProperty('startTime')) {
        obj['startTime'] = ApiClient.convertToType(data['startTime'], 'String');
      }
      if (data.hasOwnProperty('status')) {
        obj['status'] = ApiClient.convertToType(data['status'], 'String');
      }
      if (data.hasOwnProperty('sunday')) {
        obj['sunday'] = ApiClient.convertToType(data['sunday'], 'String');
      }
      if (data.hasOwnProperty('sundayTime')) {
        obj['sundayTime'] = ApiClient.convertToType(data['sundayTime'], ['Date']);
      }
      if (data.hasOwnProperty('system')) {
        obj['system'] = ApiClient.convertToType(data['system'], 'String');
      }
      if (data.hasOwnProperty('targetUserId')) {
        obj['targetUserId'] = ApiClient.convertToType(data['targetUserId'], 'String');
      }
      if (data.hasOwnProperty('thursday')) {
        obj['thursday'] = ApiClient.convertToType(data['thursday'], 'String');
      }
      if (data.hasOwnProperty('thursdayTime')) {
        obj['thursdayTime'] = ApiClient.convertToType(data['thursdayTime'], ['Date']);
      }
      if (data.hasOwnProperty('timeCompleteAt')) {
        obj['timeCompleteAt'] = ApiClient.convertToType(data['timeCompleteAt'], 'Date');
      }
      if (data.hasOwnProperty('timeCompleteBy')) {
        obj['timeCompleteBy'] = ApiClient.convertToType(data['timeCompleteBy'], 'Date');
      }
      if (data.hasOwnProperty('title')) {
        obj['title'] = ApiClient.convertToType(data['title'], 'String');
      }
      if (data.hasOwnProperty('tuesday')) {
        obj['tuesday'] = ApiClient.convertToType(data['tuesday'], 'String');
      }
      if (data.hasOwnProperty('tuesdayTime')) {
        obj['tuesdayTime'] = ApiClient.convertToType(data['tuesdayTime'], ['Date']);
      }
      if (data.hasOwnProperty('updatedByUserId')) {
        obj['updatedByUserId'] = ApiClient.convertToType(data['updatedByUserId'], 'String');
      }
      if (data.hasOwnProperty('userId')) {
        obj['userId'] = ApiClient.convertToType(data['userId'], 'String');
      }
      if (data.hasOwnProperty('wednesday')) {
        obj['wednesday'] = ApiClient.convertToType(data['wednesday'], 'String');
      }
      if (data.hasOwnProperty('wednesdayTime')) {
        obj['wednesdayTime'] = ApiClient.convertToType(data['wednesdayTime'], ['Date']);
      }
      if (data.hasOwnProperty('year')) {
        obj['year'] = ApiClient.convertToType(data['year'], 'String');
      }
    }
    return obj;
  }

  /**
   * @member {String} body
   */
  exports.prototype['body'] = undefined;
  /**
   * @member {String} countryCode
   */
  exports.prototype['countryCode'] = undefined;
  /**
   * @member {String} currencyCode
   */
  exports.prototype['currencyCode'] = undefined;
  /**
   * @member {Date} dateCreated
   */
  exports.prototype['dateCreated'] = undefined;
  /**
   * @member {String} dayOfMonth
   */
  exports.prototype['dayOfMonth'] = undefined;
  /**
   * @member {String} dayPeriodOfMonth
   */
  exports.prototype['dayPeriodOfMonth'] = undefined;
  /**
   * @member {String} dependencies
   */
  exports.prototype['dependencies'] = undefined;
  /**
   * @member {String} derivedFrom
   */
  exports.prototype['derivedFrom'] = undefined;
  /**
   * @member {String} description
   */
  exports.prototype['description'] = undefined;
  /**
   * @member {String} displayDate
   */
  exports.prototype['displayDate'] = undefined;
  /**
   * @member {String} displayDay
   */
  exports.prototype['displayDay'] = undefined;
  /**
   * @member {String} endAfterRecurrences
   */
  exports.prototype['endAfterRecurrences'] = undefined;
  /**
   * @member {String} endTime
   */
  exports.prototype['endTime'] = undefined;
  /**
   * @member {String} everyNoOfDays
   */
  exports.prototype['everyNoOfDays'] = undefined;
  /**
   * @member {String} everyNoOfMonths
   */
  exports.prototype['everyNoOfMonths'] = undefined;
  /**
   * @member {String} everyNoOfWeeks
   */
  exports.prototype['everyNoOfWeeks'] = undefined;
  /**
   * @member {String} everyWeek
   */
  exports.prototype['everyWeek'] = undefined;
  /**
   * @member {String} friday
   */
  exports.prototype['friday'] = undefined;
  /**
   * @member {Array.<Date>} fridayTime
   */
  exports.prototype['fridayTime'] = undefined;
  /**
   * @member {Date} generateEndDate
   */
  exports.prototype['generateEndDate'] = undefined;
  /**
   * @member {Date} generateStartDate
   */
  exports.prototype['generateStartDate'] = undefined;
  /**
   * @member {String} id
   */
  exports.prototype['id'] = undefined;
  /**
   * @member {Array.<String>} instructorIds
   */
  exports.prototype['instructorIds'] = undefined;
  /**
   * @member {Date} lastUpdatedDateTime
   */
  exports.prototype['lastUpdatedDateTime'] = undefined;
  /**
   * @member {String} managerComments
   */
  exports.prototype['managerComments'] = undefined;
  /**
   * @member {Number} maxSpace
   */
  exports.prototype['maxSpace'] = undefined;
  /**
   * @member {String} message
   */
  exports.prototype['message'] = undefined;
  /**
   * @member {String} monday
   */
  exports.prototype['monday'] = undefined;
  /**
   * @member {Array.<Date>} mondayTime
   */
  exports.prototype['mondayTime'] = undefined;
  /**
   * @member {String} name
   */
  exports.prototype['name'] = undefined;
  /**
   * @member {Array.<String>} notificationUserIds
   */
  exports.prototype['notificationUserIds'] = undefined;
  /**
   * @member {Number} numberOfBooks
   */
  exports.prototype['numberOfBooks'] = undefined;
  /**
   * @member {String} numberOfDaysToGenerate
   */
  exports.prototype['numberOfDaysToGenerate'] = undefined;
  /**
   * @member {String} price
   */
  exports.prototype['price'] = undefined;
  /**
   * @member {String} priority
   */
  exports.prototype['priority'] = undefined;
  /**
   * @member {Date} recurrenceEndDate
   */
  exports.prototype['recurrenceEndDate'] = undefined;
  /**
   * @member {Date} recurrenceStartDate
   */
  exports.prototype['recurrenceStartDate'] = undefined;
  /**
   * @member {String} recurrenceType
   */
  exports.prototype['recurrenceType'] = undefined;
  /**
   * @member {String} roleType
   */
  exports.prototype['roleType'] = undefined;
  /**
   * @member {String} roomId
   */
  exports.prototype['roomId'] = undefined;
  /**
   * @member {String} saturday
   */
  exports.prototype['saturday'] = undefined;
  /**
   * @member {Array.<Date>} saturdayTime
   */
  exports.prototype['saturdayTime'] = undefined;
  /**
   * @member {String} searchId
   */
  exports.prototype['searchId'] = undefined;
  /**
   * @member {String} serviceId
   */
  exports.prototype['serviceId'] = undefined;
  /**
   * @member {String} setId
   */
  exports.prototype['setId'] = undefined;
  /**
   * @member {Boolean} setsRequired
   */
  exports.prototype['setsRequired'] = undefined;
  /**
   * @member {String} shift
   */
  exports.prototype['shift'] = undefined;
  /**
   * @member {Date} startDate
   */
  exports.prototype['startDate'] = undefined;
  /**
   * @member {String} startTime
   */
  exports.prototype['startTime'] = undefined;
  /**
   * @member {String} status
   */
  exports.prototype['status'] = undefined;
  /**
   * @member {String} sunday
   */
  exports.prototype['sunday'] = undefined;
  /**
   * @member {Array.<Date>} sundayTime
   */
  exports.prototype['sundayTime'] = undefined;
  /**
   * @member {String} system
   */
  exports.prototype['system'] = undefined;
  /**
   * @member {String} targetUserId
   */
  exports.prototype['targetUserId'] = undefined;
  /**
   * @member {String} thursday
   */
  exports.prototype['thursday'] = undefined;
  /**
   * @member {Array.<Date>} thursdayTime
   */
  exports.prototype['thursdayTime'] = undefined;
  /**
   * @member {Date} timeCompleteAt
   */
  exports.prototype['timeCompleteAt'] = undefined;
  /**
   * @member {Date} timeCompleteBy
   */
  exports.prototype['timeCompleteBy'] = undefined;
  /**
   * @member {String} title
   */
  exports.prototype['title'] = undefined;
  /**
   * @member {String} tuesday
   */
  exports.prototype['tuesday'] = undefined;
  /**
   * @member {Array.<Date>} tuesdayTime
   */
  exports.prototype['tuesdayTime'] = undefined;
  /**
   * @member {String} updatedByUserId
   */
  exports.prototype['updatedByUserId'] = undefined;
  /**
   * @member {String} userId
   */
  exports.prototype['userId'] = undefined;
  /**
   * @member {String} wednesday
   */
  exports.prototype['wednesday'] = undefined;
  /**
   * @member {Array.<Date>} wednesdayTime
   */
  exports.prototype['wednesdayTime'] = undefined;
  /**
   * @member {String} year
   */
  exports.prototype['year'] = undefined;



  return exports;
}));





// WEBPACK FOOTER //
// ./clientLibsDevelopment/src/model/ScheduleBean.js